import { h, Component } from 'preact';

import { configure } from '../../../config';

import { Desktop } from './device/desktop.js';
import { Tablet } from './device/tablet.js';
import { Phone } from './device/phone.js';

import {
	initializeTaboolaJs,
	finalizeTaboolaJs
} from '../../pieces/taboola-js';
import { enablePageRefresh, COMMON_CONFIGS, setTheme } from '../../../lib/page';
import { initNewsroom } from '../../../lib/newsroom';
import {
	getPageConfig,
	isDesktop,
	getDeviceTemplate
} from '../../../lib/device';
import { persistCookies } from '../../../lib/cookies';
import { trackPageLoad } from '../../../lib/tracking';

import { trackingProvider, DIMENSION } from '@cube/track';
import { deviceVariance, containerSize } from '@cube/blocks';

@trackingProvider({
	[DIMENSION.componentpath]: 'HomePage'
})
@configure({
	...COMMON_CONFIGS,
	pageConfig: 'singleCube.pages.home',
	clientDisplayName: 'clientDisplayName',
	firebaseConfig: 'firebaseConfig'
})
@deviceVariance()
@containerSize({ height: false, target: 'self' })
export default class Home extends Component {
	componentWillMount() {
		let device = this.props.device,
			pageConfig = getPageConfig(this.props.pageConfig, device);
		this.setState({
			pageConfig,
			Device: getDeviceTemplate({ device, Desktop, Tablet, Phone })
		});

		setTheme(pageConfig);

		initializeTaboolaJs({ home: 'auto' });

	}

	componentDidMount() {
		enablePageRefresh(this.state.pageConfig);
		finalizeTaboolaJs();
		persistCookies();
		trackPageLoad(this.context);
		let device = this.props.device,
		 pageDashboard = isDesktop(device)
				? 'EN Portal - Homepage'
				: 'EN Portal Mobile - Homepage';
		setTimeout(() => {
			initNewsroom({
				taboolaConfig: this.props.taboolaConfig,
				pageTemplate: 'EN Homepage',
				pageDashboard
			});
		}, 3000);
	}

	render(props, { Device, pageConfig }) {
		return <Device {...props} pageConfig={pageConfig} />;
	}
}
